import { render, staticRenderFns } from "./device_sel.vue?vue&type=template&id=8c15a1a8&scoped=true"
import script from "./device_sel.vue?vue&type=script&lang=js"
export * from "./device_sel.vue?vue&type=script&lang=js"
import style0 from "./device_sel.vue?vue&type=style&index=0&id=8c15a1a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c15a1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c15a1a8')) {
      api.createRecord('8c15a1a8', component.options)
    } else {
      api.reload('8c15a1a8', component.options)
    }
    module.hot.accept("./device_sel.vue?vue&type=template&id=8c15a1a8&scoped=true", function () {
      api.rerender('8c15a1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_sel.vue"
export default component.exports